export function PipelineStats({ pipeline, invoices }) {
  const fmt = (a) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(a || 0);

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-6">
      <h3 className="font-bold text-[#0A1628] mb-4">Pipeline & Invoices</h3>
      <div className="grid grid-cols-2 gap-3">
        <Stat label="Total Clients" value={pipeline.total_clients} />
        <Stat label="Active Leads" value={pipeline.total_leads} />
        <Stat label="Quotes Sent" value={pipeline.total_quotes} />
        <Stat label="Quotes Signed" value={pipeline.signed_quotes} />
        <Stat label="Quote Pipeline" value={fmt(pipeline.total_quote_value)} />
        <Stat label="Signed Value" value={fmt(pipeline.signed_quote_value)} />
        <Stat label="Invoices Paid" value={invoices.paid} color="text-green-600" />
        <Stat label="Invoices Pending" value={invoices.pending} color="text-yellow-600" />
      </div>
    </div>
  );
}

function Stat({ label, value, color }) {
  return (
    <div className="bg-gray-50 rounded-lg p-3">
      <p className="text-[10px] text-gray-400 uppercase font-semibold">{label}</p>
      <p className={`text-lg font-bold ${color || 'text-[#0A1628]'}`}>{value}</p>
    </div>
  );
}
